import { Component, OnInit, Input, Output, EventEmitter}
from "@angular/core";
import { Router, ActivatedRoute }                       from "@angular/router";
import {NgbDateStruct, NgbDatepickerConfig}                  from "@ng-bootstrap/ng-bootstrap";
import { User, UserContactInfo, Salutation, Error }
from "../../../../models";
import { CurrentUserService }    from "../../../../services/shared";
import { CommonUtility }                from "../../../../utils/commonUtility";
import { USERHOMECONSTANTS }            from "../../userHome.constants";
import { UserHomeService }              from "../../userHome.service";
import { StaticUserDataService }        from "../../../../services/staticUserData.service";
import { UserContactInfoService }       from "./contactInfo.service";
import * as swal                        from "sweetalert2";
import {NgProgressService}              from "ng2-progressbar";
@Component({
    selector: "contact-info",
    template: `
    <div [ngSwitch]="isEditMode">
      <template [ngSwitchCase]="true"> ${require("./contactInfoEdit.component.html")} </template>
      <template ngSwitchDefault> ${require("./contactInfo.component.html")} </template>
    </div>`,
    providers: [UserContactInfoService, NgbDatepickerConfig]
})

export class UserContactInfoComponent implements OnInit {
    @Input() userDetails: User;
    @Output() refreshUserDetails: EventEmitter<any> = new EventEmitter();
    @Output() handleProcessing: EventEmitter<any> = new EventEmitter();
    salutationList: Salutation[];
    userContactInfo: UserContactInfo;
    errorMessage: string;
    errors: Error[];
    currentDate: Date = new Date();
    ngbDateOfBirth: NgbDateStruct;
    isEditMode: boolean;
    isProcessing: boolean;
    hasEditPermission: boolean = false;

    constructor(private pService: NgProgressService,
        private currentUserService: CurrentUserService,
        private cecRouter: Router,
        private cecActivatedRoute: ActivatedRoute,
        private userContactInfoService: UserContactInfoService,
        private userHomeService: UserHomeService,
        private staticUserDataService: StaticUserDataService,
        private commonUtility: CommonUtility,
        private config: NgbDatepickerConfig) {
        config.minDate = { year: 1900, month: 2, day: 1 };
        config.maxDate = { year: this.currentDate.getFullYear(), month: this.currentDate.getMonth() + 1, day: this.currentDate.getDate() };
        this.isProcessing = false;
    }

    // region: Event handlers
    ngOnInit() {
        this.errorMessage = "";
        this.errors = [];
        this.isEditMode = false;
        this.userContactInfo = new UserContactInfo();

        // Apply security rules
        // Global admins, diocesan admin and organisation admin can edit contact details or logged in user can edit own contact details
        let token = this.currentUserService.token;
        if (token) {
            // Global admins, diocesan admin and organisation admin can edit contact details
            if (this.cecActivatedRoute.snapshot.queryParams[USERHOMECONSTANTS.params.accountId]) {
                this.hasEditPermission =
                    this.currentUserService.IsGlobalAdmin() ||
                    this.currentUserService.IsDiocesanAdmin() ||
                    this.currentUserService.IsOrgAdmin();
            } else {
                // Logged in user can edit own contact details
                this.hasEditPermission = true;
            }
        };
    }

    onDateOfBirthChange(dateOfBirth) {
        this.ngbDateOfBirth = dateOfBirth;
        this.userContactInfo.dateOfBirth = new Date(this.ngbDateOfBirth.year, this.ngbDateOfBirth.month - 1, this.ngbDateOfBirth.day);
    }

    onContactEditSubmit() {
        // Map view to edit model 
        Object.keys(this.userDetails).forEach(key => this.userContactInfo[key] = this.userDetails[key]);
        if (!this.salutationList) {
            // Initialise with static data
            this.salutationList = this.staticUserDataService.GetSalutationList();
        }
        if (this.userContactInfo.dateOfBirth) {
            this.ngbDateOfBirth = this.commonUtility.ConvertDateStringToNgbDate(this.userContactInfo.dateOfBirth.toString());
        }
        this.isEditMode = true;
    }

    isMobileValid() {
        if (this.userContactInfo.mobile == null || this.userContactInfo.mobile.trim().length === 0) return false;

        let spaces = new RegExp("\\s+", "g");
        this.userContactInfo.mobile = this.userContactInfo.mobile.replace(spaces, "");

        // regular expression for the default system value
        let defaultRegex = new RegExp("^0?40*$");

        if (defaultRegex.test(this.userContactInfo.mobile)) {
            return false;
        }
        return true;
    }

    isDobValid() {
        if (this.userContactInfo.dateOfBirth == null) return false;
        if (Object.prototype.toString.call(this.userContactInfo.dateOfBirth) !== "[object Date]") {
            this.userContactInfo.dateOfBirth = new Date(String(this.userContactInfo.dateOfBirth));
        }
        let defaultDates = [ new Date(1901, 0, 1), new Date(2014, 0, 1), new Date(2015, 0, 1), new Date(2016, 0, 1) ];

        for (let i in defaultDates) {
            if (defaultDates[i].getTime() === this.userContactInfo.dateOfBirth.getTime()) return false;
        }
        return true;
    }

    // this method not only validates the inputs but also is responsible for displaying the error messages
    isContactInfoValid() {
        let errorTitle = "";
        let errorMessage = "";
        if (!this.isMobileValid()) {
            errorTitle = "Default value for mobile number detected.";
            errorMessage = "Please enter a proper mobile number.";
        } else if (!this.isDobValid()) {
            errorTitle = "Default value for date of birth detected.";
            errorMessage = "Please enter your correct date of birth.";
        }

        if (errorMessage != null && errorMessage !== "") {
            swal(
                errorTitle,
                errorMessage,
                "error"
            );
            return false;
        }
        return true;

    }

    onContactInfoSave() {
        // validate contact info details before submitting to the backend
        if (!this.isContactInfoValid()) return;

        this.pService.start();
        this.errorMessage = "";
        this.errors = [];
        this.isProcessing = true;
        this.handleProcessing.emit(true);

        
        // Update contact info in the DB
        this.userContactInfoService
            .Update(this.userContactInfo)
            .subscribe(
            (response: User) => {
                this.userHomeService.userDetailsUpdateConfirm(response);
                this.isEditMode = false;
                swal({
                    title: "Update Confirmed!",
                    text: "Request has been processed successfully",
                    type: "success",
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 1500
                });
                let impUserId = this.cecActivatedRoute.snapshot.queryParams[USERHOMECONSTANTS.params.userId];
                if (impUserId) {    // if user is currently looking at another user's profile
                    let navigationExtras = {
                        queryParams: { "userId": impUserId, "tabId": USERHOMECONSTANTS.tabIds.myDetailsId }
                    };
                    this.cecRouter.navigate(["/home"], navigationExtras);
                } else {            // if user is currently looking at their own profile
                    // change the token's missingMobileOrDob to "False" to make sure the user won't be forced to correct their contact details again
                    let token = this.currentUserService.token;
                    token.missingMobileOrDob = "False";
                    this.currentUserService.token = token;
                    this.cecRouter.navigate(["/home"], { queryParams: { "tabId": USERHOMECONSTANTS.tabIds.myDetailsId } });
                }
            },
            (error) => {
                let paersedErrors = JSON.parse(error._body);
                if (paersedErrors) {
                    this.errorMessage = paersedErrors.message;
                    this.errors = paersedErrors.errors;
                    let popupMessage = "You do not have permission to update contact details!";
                    if (this.errors) {
                        popupMessage = this.errors[0].message;
                    }
                    swal(
                        paersedErrors.message,
                        popupMessage,
                        "error"
                    );
                }
            })
            .add(t => {
                this.isProcessing = false;
                this.handleProcessing.emit(false);
                this.isEditMode = false;
            });
        this.pService.done();
        this.isEditMode = false;
    }

    onContactEditCancel() {
        this.isEditMode = false;
    }

    onHandleProcessing(isProcessing) {
        this.isProcessing = isProcessing;
    }

    // endRegion: Event handlers

    // public GetUserDetails(): void {
    //     this.userDetailsService
    //         .GetUserDetails("")
    //         .subscribe(
    //         (response: User) => {
    //             this.refreshUserDetails.emit(response);
    //         },
    //         (error) => {
    //             let paersedErrors = JSON.parse(error._body);
    //             if (paersedErrors) {
    //                 this.errorMessage = paersedErrors.message;
    //             }
    //         });
    // }

}


// WEBPACK FOOTER //
// ./src/app/modules/userHome/userDetails/contactInfo/contactInfo.component.ts